<template>
  <section class="contribute">
    <div class="container">
      <a-typography-title :level="1">
        如何参与社区贡献?
      </a-typography-title>
      <a-typography-paragraph>
        我们热忱欢迎每位热爱云原生技术的开发者加入社区。<br>
        在这里，微小的改变和参与都是成为社区开发者的开始，响应“我为人人、人人为我”的号召，一起改变世界！<br>
        在云原生算力治理开源社区里，您可以参与交流和贡献的方式包括但不限于：<br>
        报告错误、贡献代码、贡献文档等。
      </a-typography-paragraph>
      <a-row>
        <a-col :xs="24" :lg="{offset:3,span:8}" :order="1">
          <div class="item">
            <a-typography-title :level="5">
              参与<i>代码或文档贡献</i>
            </a-typography-title>
            <a-typography-paragraph>
              <p><b>Fork：</b>fork 项目到自己的 GitHub 账户</p>
              <p><b>Clone：</b>clone 项目到本地开发环境</p>
              <p><b>PR：</b>创建新的 pull request 完成贡献</p>
              <p><b>文档：</b>编写文档库，整理基础工具使用相关的文档</p>
              <p><b>BUG：</b>寻找星汉未来产品的bug并在GitHub提交</p>
            </a-typography-paragraph>
          </div>
        </a-col>
        <a-col :xs="0" :lg="13" :order="2">
          <i class="image i_1" />
        </a-col>
        <a-col :xs="0" :lg="13"
               :order="$Store.Public().width>$Enum.GridEnum.LG?3:4">
          <i class="image i_2" />
        </a-col>
        <a-col :xs="24" :lg="8"
               :order="$Store.Public().width>$Enum.GridEnum.LG?4:3">
          <div class="item">
            <a-typography-title :level="5">
              参与<i>技术社区布道</i>
            </a-typography-title>
            <a-typography-paragraph>
              <p><b>文章征集：</b><br>原创“云原生”相关文章在相关平台发布</p>
              <p><b>技术视频：</b><br>录制使用教程视频在相关平台发布</p>
              <p><b>活跃技术氛围：</b><br>在社群、微博等公众平台积极交流技术、活跃社区气氛</p>
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
export default {
  name: 'community_contribute'
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/community/';

.contribute {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  position: relative;
  margin: 0;
  .font(center, @title, @color_12, @title, true);
  
  &::before {
    content: '';
    display: block;
    .position(bottom, -20px);
    width: 24px;
    height: 2px;
    margin: 0 auto;
    background: @color_black;
  }
}

div.ant-typography {
  margin: @margin 0 0;
  .font(center, @text+@line, @color_13, @text);
}

.ant-row {
  margin: @margin 0 0;
  
  .ant-col {
    position: relative;
  }
}

.item {
  max-width: 450px;
  padding: 50px 0;
  
  h5.ant-typography {
    margin: 0;
    .font(justify, @text_big+@line, @color_12, @text_big, true);
    
    i {
      margin-left: 5px;
      .font(justify, @title_sub, @color_11, @title_sub, true);
    }
  }
  
  div.ant-typography {
    margin: 10px 0 0;
    .font(justify, @text+@line, @color_8, @text);
    
    p {
      margin: 5px 0 0;
      
      &:first-child {
        margin: 0;
      }
    }
  }
}

.image {
  display: block;
  .center();
  
  &.i_1 {
    &::before {
      .position(absolute, 50%, auto, auto, calc(~'50% - 50px'));
      .transform(translate(calc(~'-50% - var(--mouse-x,0px) * -0.01'), calc(~'-50% - var(--mouse-y,0px) * -0.01')));
      .bg('@{image}contribute_bg_1.png', 413px, 234px, true);
    }
    
    &::after {
      .position(absolute, 50%, auto, auto, calc(~'50% + 30px'));
      .transform(translate(calc(~'-50% - var(--mouse-x,0px) * -0.02'), calc(~'-50% - var(--mouse-y,0px) * -0.02')));
      .bg('@{image}contribute_image_1.png', 337px, 366px, true);
    }
  }
  
  &.i_2 {
    &::before {
      .position(absolute, 50%, auto, auto, calc(~'50% + 100px'));
      .transform(translate(calc(~'-50% - var(--mouse-x,0px) * 0.01'), calc(~'-50% - var(--mouse-y,0px) * 0.01')));
      .bg('@{image}contribute_bg_2.png', 316px, 278px, true);
    }
    
    &::after {
      .position(absolute, 50%, auto, auto, calc(~'50% - 80px'));
      .transform(translate(calc(~'-50% - var(--mouse-x,0px) * 0.02'), calc(~'-50% - var(--mouse-y,0px) * 0.02')));
      .bg('@{image}contribute_image_2.png', 460px, 272px, true);
    }
  }
  
  &::before,
  &::after {
    content: '';
    display: block;
  }
}

@media screen and (max-width: -1px+@grid_lg) {
  .ant-row {
    margin: 0;
  }
  
  .item {
    padding: 30px 0 0;
    margin: 0 auto;
    
    h5.ant-typography {
      text-align: center;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .contribute {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
  }
  
  div.ant-typography {
    .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
  }
  
  .item {
    h5.ant-typography {
      .font(justify, @text_big_mo+@line_mo, @color_12, @text_big_mo, true);
      
      i {
        margin-left: 2px;
        .font(justify, @title_sub_mo, @color_11, @title_sub_mo, true);
      }
    }
    
    div.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_8, @text_mo);
    }
  }
}
</style>